import React, { Component } from "react";
import ReactDOM from "react-dom";
import Carousel from "nuka-carousel";
import "./TestimonialContent.css";
import TestimonialData from "../data/TestimonialData.json";

function DemoCarousel() {
  return (
    <Carousel className="testi-carousel"
      autoplay="true"
      autoplayInterval={2000}
      wrapAround={true}
      renderCenterLeftControls={({ previousSlide }) => (
        <button onClick={previousSlide} className="preBtn">
          &lsaquo;
        </button>
      )}
      renderCenterRightControls={({ nextSlide }) => (
        <button onClick={nextSlide} className="nextBtn">
          &rsaquo;
        </button>
      )}
    >
      {TestimonialData.map((user) => {
        return (
          <div className="nuka-box">
            <div className="testimonial-content-wrap">
              <div className="testimonial-content-row">
                <div className="testimonial-content-box">
                  <img
                    src={user.img}
                    alt="testimonial avatar"
                    className="testimonial-avatar"
                  />
                  <div className="testi_wrap">
                    <h3 className="testi-user">{user.testi_name}</h3>
                  <p className="testi-loca">
                    {" "}
                    {user.testi_designation}, {user.testi_location}{" "}
                  </p>
                  </div>
                </div>
              </div>
              <div className="testimonial-content-row">
                <div className="testimonial-content-box">
                  <p
                    className="testi-para"
                    dangerouslySetInnerHTML={{ __html: user.testi_para }}
                  />
                  {/* <p className="testi-para">{user.testi_para}</p> */}
                  
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </Carousel>
  );
}

export default DemoCarousel;
